import { render } from "./TutorDetailComponent.vue?vue&type=template&id=08fe2cf7&scoped=true"
import script from "./TutorDetailComponent.vue?vue&type=script&lang=js"
export * from "./TutorDetailComponent.vue?vue&type=script&lang=js"

import "./TutorDetailComponent.vue?vue&type=style&index=0&id=08fe2cf7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fe2cf7"]])

export default __exports__